module.exports = __webpack_public_path__ + "img/imagen31.ae2887d9.jpg";